<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Read Email</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <!-- Page Title Header Starts-->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="content-header">
            <p>Preview Email templates.</p>
            <mat-divider></mat-divider>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="email-menu">
            <mat-nav-list dense>
              <mat-list-item>
                <mat-icon matListIcon>create</mat-icon>
                <a matLine routerLink="/compose-email">Compose</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>mail</mat-icon>
                <a matLine routerLink="/email">Inbox</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>send</mat-icon>
                <a matLine routerLink="/email">Sent</a>
              </mat-list-item>
              <mat-list-item class="mat-list-item-selected">
                <mat-icon matListIcon>drafts</mat-icon>
                <a matLine routerLink="/read-email">Templates</a>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <div class="page-content">
            <mat-toolbar class="email-toolbar">
              <span>Accepted Application Letter</span>
              <span class="example-spacer"></span>
              <button mat-icon-button class="example-icon" aria-label="view attachment">
                <mat-icon>file_copy</mat-icon>
              </button>
            </mat-toolbar>
            <mat-tab-group>
              <mat-tab label="Accepted">
                <div>
                  <p class="text-right">18th December, 2020</p>
                  <p>Student ID: 5210030002</p>
                  <div>
                    <p>Akosua Nkansah Osei Sasu,<br>
                      P.O. Box SN280,<br>
                      Santasi – Kumasi,<br>
                      Ghana.
                    </p>
                  </div>
                  <p>Dear Ms. Osei Sasu,</p>
                  <h5>OFFER OF ADMISSION FOR THE 2021 ACADEMIC YEAR: 4-YEAR DEGREE IN JEWELLERY DESIGN
                    TECHNOLOGY PROGRAMME</h5>
                  <ol>
                    <li>We write to offer you admission to AsanSka University College of Design and Technology to pursue a
                      4-year Degree in Jewellery Design Technology programme, regular session, starting from 2021
                      Academic Year. You shall start from level 100.</li>
                    <li>Admission is granted for a specific year only and a successful candidate who fails to
                      enroll that year or withdraws from the programme without prior approval of the Registrar
                      forfeits his/her admission. Such a candidate shall be required to purchase and complete a
                      set of fresh application forms if he/she wishes to apply for admission in the subsequent
                      year.</li>
                    <li>You need to indicate your acceptance of this offer by witting and making a full payment
                      of a non-refundable amount of Five Thousand, Two Hundred and Ninety-Nine Ghana Cedis (GH Ȼ
                      5,299.00) as your fees for the year before Friday 15th January 2021. (The components of the
                      fees is attached). The College reserves the right to revise the fees anytime without
                      notice.<br>
                      Payment should be made to any Fidelity Bank, Ghana Ltd across the country with the Account
                      Number: 1050071040412.<br>
                      Please ensure that your Name and Student ID as it appears on your admission letter are
                      written on the pay-in-slip. Students who pay their fees into any other account or bank other
                      than the one specified above will not be registered for the programme. You shall be replaced
                      with those on the waiting list if you do not pay the full fees on or before 15th January
                      2021.
                    </li>
                    <li>All students are considered to be on probation for the full duration of the programme
                      and may be dismissed at any time for misconduct. He/she shall be required to adhere to ALL
                      the College regulations as contained in the Students Handbook. If it’s discovered later that
                      you do not in actual fact possess the qualifications by virtue of which you were offered
                      admission to the programme of study, you shall be withdrawn or dismissed immediately. You
                      shall also be held personally responsible for any false statement or omission made by you at
                      the time of your application.</li>
                    <li>The accommodation of students is not the issue of Management of AsanSka University College of
                      Design and Technology. However, Management is making the effort to liaise with some Hostel
                      operators in and around Oyibi and to where needy students shall be directed to for
                      their lodging request.</li>
                    <li>Registration shall start on Monday, 25th January, 2021 and Orientation begins on
                      Wednesday, 27th January 2021.</li>
                    <li>All students especially the Freshers are required to report at the Administration on
                      25th January 2021 prompt.</li>
                    <li>Accept our Congratulations.</li>
                  </ol>
                  <p>Yours faithfully,</p>
                  <p>For: Registrar</p>
                </div>
                <mat-divider></mat-divider>
                <div class="attachments">
                  <h6>Attachments</h6>
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <mat-card class="example-card">
                        <img mat-card-image
                          src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/envelope-in-pdf-file-email-pdf-document-flat-royalty-free-illustration-1581700117.jpg"
                          alt="Admission Acceptance letters">
                        <mat-card-actions>
                          <button mat-button>View</button>
                          <button mat-button>Download</button>
                        </mat-card-actions>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Rejected">
                <div>
                  <p class="text-right">18th December, 2020</p>
                  <p>Student ID: 5210030002</p>
                  <div>
                    <p>Akosua Nkansah Osei Sasu,<br>
                      P.O. Box SN280,<br>
                      Santasi – Kumasi,<br>
                      Ghana.
                    </p>
                  </div>
                  <p>Dear Ms. Osei Sasu,</p>
                  <h5>REJECTION OF ADMISSION APPLICATION SUBMITTED FOR THE YEAR 2021 ACADEMIC YEAR: 4-YEAR DEGREE IN
                    JEWELLERY DESIGN TECHNOLOGY PROGRAMME</h5>
                  <ol>
                    <li>We write to offer you admission to Asanska College of Design and Technology to pursue a
                      4- year Degree in Jewellery Design Technology programme, regular session, starting from 2021
                      Academic Year. You shall start from level 100.</li>
                    <li>Admission is granted for a specific year only and a successful candidate who fails to
                      enroll that year or withdraws from the programme without prior approval of the Registrar
                      forfeits his/her admission. Such a candidate shall be required to purchase and complete a
                      set of fresh application forms if he/she wishes to apply for admission in the subsequent
                      year.</li>
                    <li>You need to indicate your acceptance of this offer by witting and making a full payment
                      of a non-refundable amount of Five Thousand, Two Hundred and Ninety-Nine Ghana Cedis (GH Ȼ
                      5,299.00) as your fees for the year before Friday 15th January 2021. (The components of the
                      fees is attached).The College reserves the right to revise the fees anytime without
                      notice.<br>
                      Payment should be made to any Fidelity Bank, Ghana Ltd across the country with the Account
                      Number: 1050071040412.<br>
                      Please ensure that your Name and Student ID as it appears on your admission letter are
                      written on the pay-in-slip. Students who pay their fees into any other account or bank other
                      than the one specified above will not be registered for the programme. You shall be replaced
                      with those on the waiting list if you do not pay the full fees on or before 15th January
                      2021.
                    </li>
                    <li>All students are considered to be on probation for the full duration of the programme
                      and may be dismissed at any time for misconduct. He/she shall be required to adhere to ALL
                      the College regulations as contained in the Students Handbook. If it’s discovered later that
                      you do not in actual fact possess the qualifications by virtue of which you were offered
                      admission to the programme of study, you shall be withdrawn or dismissed immediately. You
                      shall also be held personally responsible for any false statement or omission made by you at
                      the time of your application.</li>
                    <li>The accommodation of students is not the issue of Management of AsanSka University College of
                      Design and Technology. However, Management is making the effort to liaise with some Hostel
                      operators in and around Oyibi and to where needy students shall be directed to for
                      their lodging request.</li>
                    <li>Registration shall start on Monday, 25th January, 2021 and Orientation begins on
                      Wednesday, 27th January 2021.</li>
                    <li>All students especially the Freshers are required to report at the Administration on
                      25th January 2021 prompt.</li>
                    <li>Accept our Congratulation.</li>
                  </ol>
                  <p>Yours faithfully,</p>
                  <p>For: Registrar</p>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
